import { FC } from 'react';
import MainContent from '../../../components/Generic/MainContent';
import AdminHeader from './AdminHeader';

type AdminContentProps = {
  title: string;
  description: string;
};

const AdminContent: FC<AdminContentProps> = ({
  title,
  description,
  children,
}) => {
  return (
    <>
      <MainContent>
        <AdminHeader title={title} description={description} />
        {children}
      </MainContent>
    </>
  );
};
export default AdminContent;
